import actionTypes from "./actionTypes";
import * as tablesUtils from "../utils/tablesUtils";

const getAA_DEF_OB_HODN_Request = () => ({
  type: actionTypes.GET_AA_DEF_OB_HODN_REQUEST,
});
const getAA_DEF_OB_HODN_Success = (res) => ({
  type: actionTypes.GET_AA_DEF_OB_HODN_SUCCESS,
  res,
});
const getAA_DEF_OB_HODN_Failure = (error) => ({
  type: actionTypes.GET_AA_DEF_OB_HODN_FAILURE,
  error,
});
export const getAA_DEF_OB_HODN = (id) => {
  return async (dispatch) => {
    try {
      dispatch(getAA_DEF_OB_HODN_Request());
      let res = await tablesUtils.getAA_DEF_OB_HODN(id);
      dispatch(getAA_DEF_OB_HODN_Success(res));
    } catch (error) {
      dispatch(getAA_DEF_OB_HODN_Failure(error));
    }
  };
};
